import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import axios from 'axios';

export interface State {
}

const defaultState: State = {
};

const actions: ActionTree<State, RootState> = {

  async sendEvent({ commit, state }, payload:any) {
    let url = document.location.href
    if(!url.includes('dev') && !url.includes('localhost')) {
      try {
        await axios.post('https://cloud.roistat.com/api/v1/project/events/bulk/send?key=d961efb50669bf61638e53b84ce5310f&project=218475', payload)
      }catch (e) {
      }
    }
  },

};

export default {
  namespaced: true,
  actions,
};
